export enum TranslationEntityTypeEnum {
  INVENTORY_ITEM = 0,
  INVENTORY_CATEGORY = 1,
  MENU = 2,
  MENU_CATEGORY = 3,
  MENU_ITEM = 4,
  MODIFIER_GROUP = 5,
  MODIFIER_ITEM = 6,
  KIOSK_PROFILE = 7,
  UNIT = 8,
  ITEM_TAG = 9,
  REASON = 10,
  SALES_TYPE = 11,
}

export enum TranslationTabEnum {
  INVENTORY = 'inventory',
  MODIFIERS = 'modifiers',
  MENUS = 'menus',
  KIOSK = 'kiosk',
  SETTINGS = 'settings',
}

export enum TranslationSectionEnum {
  INVENTORY_CATEGORIES = 'inventory_categories',
  INVENTORY_SUB_CATEGORIES = 'inventory_sub_categories',
  INVENTORY_ITEMS = 'inventory_items',
  MENUS = 'menus',
  MENU_CATEGORIES = 'menu_categories',
  MENU_SUB_CATEGORIES = 'menu_sub_categories',
  MENU_ITEMS = 'menu_items',
  MODIFIER_GROUPS = 'modifier_groups',
  MODIFIER_ITEMS = 'modifier_items',
  NON_INVENTORY_ITEMS = 'non_inventory_items',
  KIOSK = 'kiosk',
  UNITS = 'units',
  ITEM_TAGS = 'item_tags',
  REASONS = 'reasons',
  SALES_TYPES = 'sales_types',
}
